module.exports = __webpack_public_path__ + "img/labmem_text_btntest_jp.3c483e3a.png";